export const SET_INSTRUMENT_TO_TRADE = 'trader/SET_INSTRUMENT_TO_TRADE';
export const CLEAR_INSTRUMENT_TO_TRADE = 'trader/CLEAR_INSTRUMENT_TO_TRADE';
